class ProductFaqTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-faq-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-faq-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
    });

    this.select(0, { focus: false });
    this.setAttribute('data-faq-ready', '');
  }

  select(index, { focus = true } = {}) {
    const tab = this.tabs[index];
    if (!tab) return;

    this.tabs.forEach((candidate, candidateIndex) => {
      const isActive = candidateIndex === index;
      candidate.setAttribute('aria-selected', String(isActive));
      candidate.tabIndex = isActive ? 0 : -1;
      if (this.panels[candidateIndex]) {
        this.panels[candidateIndex].hidden = !isActive;
      }
    });

    if (focus) tab.focus();
  }
}

if (!customElements.get('product-faq-tabs')) {
  customElements.define('product-faq-tabs', ProductFaqTabs);
}
